/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Authorization_Expired_TitleInputs */

const en_agent_authorization_expired_title = /** @type {(inputs: Agent_Authorization_Expired_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Authorization request expired`)
};

const zh_agent_authorization_expired_title = /** @type {(inputs: Agent_Authorization_Expired_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`授权请求已过期`)
};

/**
* | output |
* | --- |
* | "Authorization request expired" |
*
* @param {Agent_Authorization_Expired_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const agent_authorization_expired_title = /** @type {((inputs?: Agent_Authorization_Expired_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Authorization_Expired_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_agent_authorization_expired_title(inputs)
	return zh_agent_authorization_expired_title(inputs)
});
export { agent_authorization_expired_title as "agent.authorization.expired_title" }